<generic-page
  image="calculatorLanding"
  [hidePortalMenu]="true"
  [showAppHeader]="false"
  [columnLayout]="false"
  >
  <div class="container">
    <mat-card>
      <form #form="ngForm" [formGroup]="pageForm" (ngSubmit)="submit()">
        <div class="header">
          <img src="assets/calculator.svg" />
          <span>Ygrene Calculator</span>
        </div>

        <!-- SECTION 1 -->
        <section-header
          [valid]="pageForm.get('address').valid"
          [touched]="pageForm.get('address').touched"
          >Where is the property?</section-header
          >
          <section-content>
            <!-- ADDRESS CONTROL -->
            <mat-form-field>
              <mat-label>Property address</mat-label>
              <ui-address-autocomplete
                placeholder="e.g. 12 Main St, Aptos, CA 92304"
                formControlName="address"
                [errorState]="pageForm.get('address').invalid && pageForm.get('address').touched"
              ></ui-address-autocomplete>
              <mat-error> Please enter a valid address</mat-error>
            </mat-form-field>
          </section-content>

          <!-- SECTION 2 -->
          <section-header
          [valid]="
            pageForm.get('custom_estimated_cost').valid && pageForm.get('estimated_cost').valid
          "
          [touched]="
            pageForm.get('custom_estimated_cost').touched || pageForm.get('estimated_cost').touched
          "
            [optional]="true"
            [optionalText]="'($5000 minimum)'"
            >Estimated project cost?</section-header
            >

            <section-content>
              <!-- COST CONTROL -->
              <select-bubbles
                formControlName="estimated_cost"
                [items]="estimatedCosts"
                [singleValue]="true"
              ></select-bubbles>

              <mat-form-field class="custom-cost-input">
                <mat-label>Or insert other amount</mat-label>
                <fa-icon matPrefix [icon]="['fas', 'dollar-sign']"></fa-icon>
                <input
                  matInput
                  placeholder="$0.00"
                  formControlName="custom_estimated_cost"
                  [thousandSeparator]="maskConfig.thousandSeparator"
                  [mask]="moneyMaskWithoutDecimal"
                  [separatorLimit]="maskConfig.separatorLimit"
                  numberInput
                  />

                @if (
                  customEstimatedCostControl().hasError('required') ||
                  estimatedCostControl().hasError('required')
                  ) {
                  <mat-error
                    >Please enter a valid project cost</mat-error
                    >
                  }

                  @if (customEstimatedCostControl().hasError('min')) {
                    <mat-error>
                      Project cost must be a minimum of $5000
                    </mat-error>
                  }

                  @if (customEstimatedCostControl().hasError('max')) {
                    <mat-error>
                      Project cost must be a maximum of $100,000,000
                    </mat-error>
                  }
                </mat-form-field>
              </section-content>

              @if (isDesktop$ | async) {
                <div class="button-wrapper">
                  <page-button [config]="{ arrow: 'right' }" [loading]="isLoading$ | async"
                    >Calculate Monthly Cost</page-button
                    >
                  </div>
                }
              </form>
            </mat-card>
          </div>
        </generic-page>

        @if (!(isDesktop$ | async)) {
          <div class="footer-wrapper" noShadowOnBottom>
            <page-footer
              [primary]="{ label: 'Calculate Monthly Cost', arrow: 'right' }"
              [primLoading]="isLoading$ | async"
              [primCenteredIfNoSecondary]="true"
              (primaryClicked)="form.onSubmit()"
              [valid]="pageForm.valid"
            ></page-footer>
          </div>
        }
